import { fill } from 'lodash';

import { Layout } from '../Layout';

import { Skeleton as ItemSkeleton } from '../../Item/Skeleton';
import { Skeleton as ButtonSkeleton } from '../../Buttons/Skeleton';

export type SkeletonProps = React.HTMLAttributes<HTMLDivElement> & {
	numItems?: number;
	editable?: boolean;
	divider?: React.ReactNode;
};

export const Skeleton: React.FC<SkeletonProps> = ({
	numItems = 1,
	editable = false,
	divider,
	className,
	...props
}) => (
	<Layout
		divider={divider}
		className={`cart-items-skeleton${className ? ` ${className}` : ''}`}
		{...props}
		children={fill(Array(numItems), null).map((_, key) => (
			<ItemSkeleton key={key} children={editable && <ButtonSkeleton />} />
		))}
	/>
);
